import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";

const CONSENT_KEY = "kc-cookie-consent";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(CONSENT_KEY)) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  function accept() {
    localStorage.setItem(CONSENT_KEY, "1");
    setVisible(false);
  }

  return (
    <AnimatePresence>
      <motion.div
        key="cookie-banner"
        initial={{ y: "100%" }}
        animate={{ y: 0 }}
        exit={{ y: "100%" }}
        transition={{ type: "tween", duration: 0.3 }}
        className="fixed bottom-0 left-0 right-0 z-50 flex flex-col sm:flex-row items-start sm:items-center gap-3 p-4 bg-bg-surface border-t border-border shadow-lg"
        role="region"
        aria-label="Cookie consent"
      >
        <p className="flex-1 text-sm text-text-secondary">
          We use <code>localStorage</code> to save your theme preference. No tracking
          cookies are used.
        </p>
        <button
          onClick={accept}
          className="shrink-0 px-4 py-2 rounded-lg bg-primary-dark text-white text-sm font-medium hover:bg-primary-light transition-colors cursor-pointer"
        >
          Got it
        </button>
      </motion.div>
    </AnimatePresence>
  );
}
